import {Injectable} from '@angular/core';
import { ObservableErrHandler} from "app/core/types/err.handling.types";
import {MultiAlertService} from "app/core/services/multi.alert.service";
import {tap} from "rxjs";

@Injectable({providedIn: 'root'})
export class ErrorHandlingService {

    constructor(
        private _multiAlertService: MultiAlertService,
    ) {}

    /**
     * This function is used to tap into provided observable and listen for errors and/or success events
     * In order that it works, caller must subscribe to errHandlerData.observable so that registered tap takes effect.
     * It uses MultiAlertService to display pop up err/success msgs
     * @param errHandlerData - ObservableErrHandler object containing details regarding observable to tap into as well as how to handle err and success messages
     *  Important:
     *   - if no observable was provided, no err handling and success info will be registerd
     *   - if no err_title or err_message provided, then no error messages will be displayed (only logged)
     *   - if no success_title or success_message provided, then no success messages will be displayed
     */
    public watchThis(errHandlerData:ObservableErrHandler){
        //only tab if observable and success or error messages were provided, otherwise makes no sense
        if((errHandlerData?.success_msg || errHandlerData?.success_title || errHandlerData?.err_title || errHandlerData?.err_message) && errHandlerData.observable)
        {
            errHandlerData.observable = errHandlerData.observable .pipe(tap(
                {
                    next: val => {},
                    error: (err:any) => {
                        if(errHandlerData.err_message || errHandlerData.err_title){
                            const errTitle= errHandlerData.err_title?errHandlerData.err_title:"Error";
                            //if no error message provided, display error message returned from request
                            const errMsg= errHandlerData.err_message?errHandlerData.err_message:err?.error?.message;
                            const placeHodlerValues = errHandlerData.place_holder_vals;
                            this._multiAlertService.setAlert('error', 15,errTitle, errMsg, placeHodlerValues);
                        }
                        //log errors to console
                        console.error(err);
                    },
                    complete: () => {
                        if(errHandlerData.success_title || errHandlerData.success_msg) {
                            const title= errHandlerData.success_title?errHandlerData.success_title:"Success";
                            const msg= errHandlerData.success_msg?errHandlerData.success_msg:"Have no worry, everything is good.";
                            const placeHodlerValues = errHandlerData.place_holder_vals;
                            this._multiAlertService.setAlert('success', 15, title, msg, placeHodlerValues);
                        }
                    }
                }
            ));
        }
    }
}



